//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { ChevronDownIcon, XIcon } from 'vue-feather-icons'
import { isArray } from 'lodash/lang'

export default {
  name: 'SearchItemDropdown',
  components: {
    ChevronDownIcon,
    XIcon
  },
  props: {
    label: {
      type: String,
      required: true
    },
    items: {
      type: Array,
      default () {
        return []
      }
    },
    selected: {
      type: [String, Number, Array],
      default: null
    },
    canRemove: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    isItemSelected (i) {
      if (isArray(this.selected)) {
        return this.selected.includes(i.id)
      }
      return this.selected === i.id
    },
    selectItem (i) {
      this.$emit('select', i)
    },
    removeSelection () {
      this.$emit('remove')
    }
  }
}
